import Allogio1 from '../../../media/Residentials/Allogio/Allogio.webp'
import Allogio2 from '../../../media/Residentials/Allogio/Allogio (2).webp'
import Allogio3 from '../../../media/Residentials/Allogio/Allogio (3).webp'
import Allogio4 from '../../../media/Residentials/Allogio/Allogio (4).webp'
import Allogio5 from '../../../media/Residentials/Allogio/Allogio (5).webp'
import Allogio6 from '../../../media/Residentials/Allogio/Allogio (6).webp'
import Allogio7 from '../../../media/Residentials/Allogio/Allogio (7).webp'
import Allogio8 from '../../../media/Residentials/Allogio/Allogio (8).webp'
import Allogio9 from '../../../media/Residentials/Allogio/Allogio (9).webp'
import Allogio10 from '../../../media/Residentials/Allogio/Allogio (10).webp'
import Allogio11 from '../../../media/Residentials/Allogio/Allogio (11).webp'
import Allogio12 from '../../../media/Residentials/Allogio/Allogio (12).webp'
import Allogio13 from '../../../media/Residentials/Allogio/Allogio (13).webp'

const Allogioimages =[
Allogio1,Allogio2,Allogio3,Allogio4,Allogio5,Allogio6,Allogio7,Allogio8,Allogio9,Allogio10,Allogio11,Allogio12,Allogio13
]

export default Allogioimages;